module.exports = __webpack_public_path__ + "static/img/bottomLogo.c8901548.png";